module.exports = __webpack_public_path__ + "static/media/conversion_5_green.d2291eca.png";